import $ from 'jquery';

const slider = () => {
  $('#top-slider').slick({
    slidesToShow: 1,
    dots: false,
    arrows: false,
    fade: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
  });
};

export default slider;
